import { css } from '@emotion/css';
import { colors } from '@editor2/styles/colors';

export const disabledInputBlock = css`
	position: relative;

	input {
		background-color: ${colors.background} !important;
		padding-right: 80px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.copyButton {
		position: absolute;
		right: 5px;
		top: 34px;
		border: 0;
		color: #6c757d80;
		cursor: pointer;

		:hover {
			color: ${colors.infoText};
			background-color: ${colors.background};
		}

		svg {
			margin-left: 5px;
		}
	}
`;
